var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"expo-btn expo-btn-white",class:{ 'btn-disabled': _vm.disabled },attrs:{"title":_vm.title},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }